import script from "./Component-02.vue?vue&type=script&setup=true&lang=js"
export * from "./Component-02.vue?vue&type=script&setup=true&lang=js"

import "./Component-02.vue?vue&type=style&index=0&id=a6b2f034&lang=scss"

const __exports__ = script;

export default __exports__